jQuery(function($){

  		// click on Apply btn
		window.rf_wheelsApply = function () {   		
			var _this = $('.rf-selector-container-active');
			var selected_vals = [];
			var this_apply_id = _this.data('picker_id');
			var selected_items = [];
			var selected_index_arr = [];
			
			_this.find('.rfsc-picker').each(function(i, picker){
				var picker_scrollTop = parseInt(Math.ceil($(this).scrollTop()));
				var picker_no = 0;
				if (picker_scrollTop == 0) {
					picker_no = 0;
				} else {
					picker_no = picker_scrollTop / 40;
				}
				selected_items.push(picker_no - 1);
				var picker_id = $(this).find('.rfsc-item').eq(picker_no).data('id');
				var picker_text = $(this).find('.rfsc-item').eq(picker_no).text();
				var obj = { 'id' : picker_id, 'value' : picker_text };
				selected_vals.push(obj);
				selected_index_arr.push($(this).find('.rfsc-item').eq(picker_no).index());
			});
			console.log('array:'+selected_vals.length);
			if (selected_vals.length >= 4) {
			if (selected_vals[0].id !== '-' && selected_vals[1].id !== '-' && selected_vals[2].id !== '-' && selected_vals[3].id !== '-') {
				_this.removeClass('rf-selector-container-active');
				$('.rf-selector-'+this_apply_id).data('selected_vals', selected_index_arr.join(";"));
				$('body').removeClass('rf-selector-body');
	        	$('html').removeClass('rf-selector-html');
	        	// var get_current_parent = parseInt($('body').find('.rf-selector-'+this_apply_id).parent()[0].scrollTop) + 150;
	        	// $('body').scrollTop(get_current_parent);
				
				var this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).position().top);
	        	if (this_height <= 0 || this_height <= 100) {
	        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().position().top);
	        		if (this_height <= 0 || this_height <= 100) {
		        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().position().top);
		        		if (this_height <= 0 || this_height <= 100) {
			        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().position().top);
			        		if (this_height <= 0) {
				        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().parent().position().top);
				        	}
			        	}
		        	}
	        	}
	        	if (this_height >= 300) {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height-900);
		        	}
	        	} else {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height+150);
		        	}
	        	}
		        
			    return selected_vals; // This is needed so other functions can keep chaining off of this
			} else if (selected_vals[0].id !== '-' && selected_vals[1].id !== '-' && selected_vals[2].id === '-' &&	 selected_vals[3].id === '-') {
				_this.removeClass('rf-selector-container-active');
				$('.rf-selector-'+this_apply_id).data('selected_vals', selected_index_arr.join(";"));
				$('body').removeClass('rf-selector-body');
	        	$('html').removeClass('rf-selector-html');
	        	// var get_current_parent = parseInt($('body').find('.rf-selector-'+this_apply_id).parent()[0].scrollTop) + 150;
	        	// $('body').scrollTop(get_current_parent);
				
				var this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).position().top);
	        	if (this_height <= 0 || this_height <= 100) {
	        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().position().top);
	        		if (this_height <= 0 || this_height <= 100) {
		        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().position().top);
		        		if (this_height <= 0 || this_height <= 100) {
			        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().position().top);
			        		if (this_height <= 0) {
				        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().parent().position().top);
				        	}
			        	}
		        	}
	        	}
	        	if (this_height >= 300) {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height-900);
		        	}
	        	} else {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height+150);
		        	}
	        	}
		        
			    return selected_vals; // This is needed so other functions can keep chaining off of this
			} else {
				if (selected_vals[0].id === '-') {
					$('.rf-selector-container-active').find('.rfsc-picker-1').addClass('rfsc-picker-required');
				}
				if (selected_vals[1].id === '-') {
					$('.rf-selector-container-active').find('.rfsc-picker-2').addClass('rfsc-picker-required');
				}
				if (selected_vals[2].id === '-' && selected_vals[3].id !== '-') {
					$('.rf-selector-container-active').find('.rfsc-picker-3').addClass('rfsc-picker-required');
				}
				if (selected_vals[2].id !== '-' && selected_vals[3].id === '-') {
					$('.rf-selector-container-active').find('.rfsc-picker-4').addClass('rfsc-picker-required');
				}
				return 'error';
			}
		} else {
			_this.removeClass('rf-selector-container-active');
				$('.rf-selector-'+this_apply_id).data('selected_vals', selected_index_arr.join(";"));
				$('body').removeClass('rf-selector-body');
	        	$('html').removeClass('rf-selector-html');
	        	// var get_current_parent = parseInt($('body').find('.rf-selector-'+this_apply_id).parent()[0].scrollTop) + 150;
	        	// $('body').scrollTop(get_current_parent);
				
				var this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).position().top);
	        	if (this_height <= 0) {
	        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().position().top);
	        		if (this_height <= 0) {
		        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().position().top);
		        		if (this_height <= 0) {
			        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().position().top);
			        		if (this_height <= 0) {
				        		this_height = parseInt($('body').find('.rf-selector-'+this_apply_id).parent().parent().parent().parent().position().top);
				        	}
			        	}
		        	}
	        	}
	        	if (this_height >= 300) {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height+100);
		        	}
	        	} else {
	        		if ($(window).width() < 1024) {
		        		window.scrollTo(0, this_height+150);
		        	}
	        	}
		        
			    return selected_vals; // This is needed so other functions can keep chaining off of this
		}
		};
		// click on Apply btn

		// window.rf_wheelsApply(); 

		var dragging = false;

		var rfsc_content_height_fix = 83;

		// click by item
		$('body').find('.rfsc-item').click(function(){
			// catch clicked item value
			var select_position = parseFloat($(this).position().top);
			$(this).parents('.rfsc-picker').animate({scrollTop: $(this).parents('.rfsc-picker')[0].scrollTop + select_position - rfsc_content_height_fix}, 40);
		});
		// click by item


		// click on Cancel btn
		$('body').find('.rfsc-head-cancel').click(function(){
			var container_id = $(this).parents('.rf-selector-container').data('picker_id');
			var wheels_qty = $(this).parents('.rf-selector-container').find('.rfsc-middle-content').find('.rfsc-picker').length;
			console.log('container_id:'+container_id+' wheels_qty:'+wheels_qty);
			$(this).parents('.rf-selector-container').removeClass('rf-selector-container-active');
			$('body').removeClass('rf-selector-body');
        	$('html').removeClass('rf-selector-html');
        	// var get_current_parent = parseInt($('body').find('.rf-selector-'+container_id).parent()[0].scrollTop) + 150;
        	// window.scrollTo( get_current_parent, 100 );
        	var this_height = parseInt($('body').find('.rf-selector-'+container_id).position().top);
        	if (this_height <= 0) {
        		this_height = parseInt($('body').find('.rf-selector-'+container_id).parent().position().top);
        		if (this_height <= 0) {
	        		this_height = parseInt($('body').find('.rf-selector-'+container_id).parent().parent().position().top);
	        		if (this_height <= 0) {
		        		this_height = parseInt($('body').find('.rf-selector-'+container_id).parent().parent().parent().position().top);
		        		if (this_height <= 0) {
			        		this_height = parseInt($('body').find('.rf-selector-'+container_id).parent().parent().parent().parent().position().top);
			        	}
		        	}
	        	}
        	}
	        if (this_height >= 300) {
	        	if ($(window).width() < 1024) {
	        		window.scrollTo(0, this_height+100);
	        	} 
        	} else {
        		if ($(window).width() < 1024) {
        			window.scrollTo(0, this_height+150);
        		} 
        	}
		});
		// click on Cancel btn

		// mouse click scroll
		$('body').find('.rfsc-picker').mousedown(function (e) {
			var current_subitems_qty = $(this).find('.rfsc-item').length;
			var max_height = current_subitems_qty * 40 + 5;
            e.preventDefault();
            dragging = true;
            var event_Y = e.pageY;
            if(event_Y%40 != 0){
		        event_Y = event_Y - event_Y%40;
		    }
            var startY = this.scrollTop + event_Y;
            $(this).mousemove(function (a) {
            	if(dragging){ 
            		// console.log(a);
            		var _this = this;
	            	var event_Y2 = a.pageY;
		            if(event_Y2%40 != 0){
				        event_Y2 = event_Y2 - event_Y2%40;
				    }
				    if (event_Y2 < 40) {
				    	event_Y2 = 40;
				    }
	                $(this).animate({scrollTop: startY - event_Y2}, 13);
			        if (_this.scrollTop > max_height) {
			        	$(this).animate({scrollTop: max_height}, 40);
			        }
	                return false;
	            }
            });
        });
        $(document).mouseup(function (e) {
        	e.preventDefault;
            $('.rfsc-picker').off("mousemove");
            dragging = false;
        });
        // mouse click scroll

        // touch events scroll
        var touch_dragging = false;
        var touch_startY = 0;
        var touch_max_height = 0;
        // touchstart events when you first press the screen with
        // your finger
        $('body').find('.rfsc-picker').on("touchstart", function(e) {           
            var current_subitems_qty = $(this).find('.rfsc-item').length;
			touch_max_height = current_subitems_qty * 40 + 5;
			touch_dragging = true;
			var event_Y = e.originalEvent.touches[0].pageY;
			if(event_Y%40 != 0){
		        event_Y = event_Y - event_Y%40;
		    }
            touch_startY = this.scrollTop + event_Y;
        });
        
        // touchmove events occur when you drag your finger
        $('body').find('.rfsc-picker').on("touchmove", function(e) {
        	// console.log(e);
            if(touch_dragging){ 
        		var _this = this;
            	var event_Y2 = e.originalEvent.touches[0].pageY;
	            if(event_Y2%40 != 0){
			        event_Y2 = event_Y2 - event_Y2%40;
			    }
			    if (event_Y2 < 40) {
			    	event_Y2 = 40;
			    }
             	$(this).animate({scrollTop: touch_startY - event_Y2}, 12);
		        if (_this.scrollTop > touch_max_height) {
		        	$(this).animate({scrollTop: touch_max_height}, 12);
		        }
                return false;
            }
        });
        
        // touchend events occur when you lift your finger
        $(document).on("touchend", function(e) {
            touch_dragging = false;
        });
        
        $('body').find('.rf-selectors').click(function(e){
        	e.stopPropagation();
        	// var this_height = parseInt($(this).position().top);
        	// console.log('this_height:'+this_height);
        	$('body').find('.rf-selector-container').removeClass('rf-selector-container-active');
        	var this_id = $(this).data('selector_id');
        	var this_s_qty = $(this).data('selectors_qty');
        	var this_selected = $(this).data('selected_vals');
        	if (this_s_qty >= 2) {
        		this_selected = this_selected.split(';');
        	}
        	
        	$('body').find('.rf-selector-container-'+this_id).addClass('rf-selector-container-active');
        	$('body').addClass('rf-selector-body');
        	$('html').addClass('rf-selector-html');

        	// $('body').animate({scrollTop: this_height}, 0);
        	

        	setTimeout(function(){
        		if (this_s_qty >= 2) {
		        	$('.rf-selector-container-'+this_id).find('.rfsc-middle-content').find('.rfsc-picker').each(function(i, val){
		        		// console.log('i: '+i);
						$(this).animate({scrollTop: this_selected[i] * 40}, 40);
		        	});
	        	} else {
	        		$('.rf-selector-container-'+this_id).find('.rfsc-middle-content').find('.rfsc-picker').animate({scrollTop: this_selected * 40}, 40);
	        	}
        	},200);
        });
  	});